import { render, staticRenderFns } from "./creatGoodsRule.vue?vue&type=template&id=28b915e4&scoped=true&"
import script from "./creatGoodsRule.vue?vue&type=script&lang=js&"
export * from "./creatGoodsRule.vue?vue&type=script&lang=js&"
import style0 from "./creatGoodsRule.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./creatGoodsRule.vue?vue&type=style&index=1&id=28b915e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b915e4",
  null
  
)

component.options.__file = "creatGoodsRule.vue"
export default component.exports